import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginGuardGuard, OportunidadesGuard, RegEmpGuard, ModRegEmpPcGuard, UsuariosPcGuard } from '../services/service.index';
import { LapruebaComponent } from './laprueba/laprueba.component';
import { MaininversionistaComponent } from './maininversionista/maininversionista.component';
import { OportunidadesComponent } from './oportunidades/oportunidades.component';
import { OportunidadComponent } from './oportunidades/oportunidad.component';
import { RegistroComponent } from './registro/registro.component';
import { RegistrousuarioComponent } from './registro/registrousuario/registrousuario.component';
import { RegistrodocumentosComponent } from './registro/registrodocumentos/registrodocumentos/registrodocumentos.component';
import { MainclienteComponent } from './maincliente/maincliente.component';
import { SolicitudcreditoComponent } from './maincliente/solicitudcredito.component';
import { RegistroempleadoComponent } from './registroempleado/registroempleado.component';
import { SignatoryesComponent } from './signatoryes/signatoryes.component';
import { SignatoryesDetComponent } from './signatoryes/signatoryesdet.component';
import { ModregempComponent } from './modregemp/modregemp.component';
import { ModregempdetComponent } from './modregemp/modregempdet.component';
import { EditarUsuarioComponent } from '../controlpanel/catalogos/usuarios/editarusuario.component';
import { ClientmodregempGuard } from '../services/guards/clientmodregemp.guard';
import { DashboardAdminComponent } from './dashboard-admin/dashboard-admin.component';

const pagesRoutes: Routes = [
        { path: 'dashboardAdmin',          component: DashboardAdminComponent },
        { path: 'registro',          component: RegistroComponent },
        { path: 'inversionista',          component: MaininversionistaComponent },
        { path: 'oportunidades',          component: OportunidadesComponent },
        { path: 'oportunidades/oportunidad/:id',          component: OportunidadComponent },
        { path: 'registrousuario',          component: RegistrousuarioComponent },
        { path: 'registrodocumentos',          component: RegistrodocumentosComponent },
        { path: 'maincliente',          component: MainclienteComponent },
        { path: 'maincliente/solicitudcredito',          component: SolicitudcreditoComponent },
        { path: 'administrador/solicitudcredito/:user_id',          component: SolicitudcreditoComponent },
        { path: 'yuc/solicitudcredito/:customer_gov_id',          component: SolicitudcreditoComponent },
        { path: 'maincliente/solicitudcredito/:customer_credit_id',          component: SolicitudcreditoComponent },
        { path: 'registroemp', component: RegistroempleadoComponent, canActivate: [RegEmpGuard] },
        { path: 'registroemp/:id', component: RegistroempleadoComponent },
       // { path: 'signatoryes', component: SignatoryesComponent },
        { path: 'signatoryes/detcred/:id', component: SignatoryesDetComponent },
        { path: 'modregemp', component: ModregempComponent, canActivate: [ModRegEmpPcGuard] },
        { path: 'modregemp/det/:id', component: ModregempdetComponent, canActivate: [ModRegEmpPcGuard] },
        { path: 'modregemp/det/:id/:cliente', component: ModregempdetComponent},
        { path: 'editarusuario/:id/:usuario',          component: EditarUsuarioComponent },
        { path: '**', redirectTo: '/home', pathMatch: 'full' }
];


export const PAGES_ROUTES = RouterModule.forChild( pagesRoutes );